// @see https://stackoverflow.com/questions/48224799/test-invisible-recaptcha hot to test captcha

exports.Captcha = require('./captcha');

exports.initForms = require('./initForms');